<h1 class="h1">{{ translations.pageTitle }}</h1>
<vue-server-messages [messages]="messages" (messageClicked)="messageClicked($event)"></vue-server-messages>

@if (validHash) {
  <vue-panel [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME" titleKey="PasswordResetUpdateComponent.PanelTitle" class="app-container">
    {{ 'RetrieveUserComponent.MandatoryFields' | translate: ACCOUNT_RECOVERY_BUNDLE_NAME | async }}
    <vue-password-strength-input
      #passwordResetComponent
      [formError]="formError"
      [validationRequiredRules]="requiredRules"
      [hasOldPassword]="false"
      [passwordInput]="passwordInput"
      [maxPasswordLength]="40">
    </vue-password-strength-input>
    <vue-form-buttons
      [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME"
      secondaryLabelKey="button.ReturnToLogin"
      primaryLabelKey="button.Submit"
      (secondaryButtonClicked)="returnToLogin()"
      (primaryButtonClicked)="submit()">
    </vue-form-buttons>
  </vue-panel>
}
